// extracted by mini-css-extract-plugin
export default {"text":"Reports_text__9YcqY"};